import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { navigate } from "gatsby";

import CheckIcon from "@icons/check_icon_new.svg";
import InfoIcon from "@icons/warning-icon-no-padding.svg";

import { localDate } from "../../utils/functions";

import BoleronLoader from "./BoleronLoader";

import "@styles/components/GloInfoBox.sass";

const GloInfoBox = ({
  title,
  subtitle,
  rowData = [],
  iconType,
  customIcon,
  status = "success",
  gloIconStyles,
  buyBtnUrl,
  isRowsAboveBtn = false,
  onBuyBtnClick,
  isBuyBtn,
  containerStyles,
  lastVerified
}) => {
  const { t } = useTranslation();
  const statusIcons = {
    success: <CheckIcon className="glo-icon success" />,
    warning: <InfoIcon className="glo-icon warning" />,
    info: <InfoIcon className="glo-icon info" />,
    loading: <BoleronLoader className="is-fullwidth mx-auto" />
  };

  const icons = {
    glo: <img src="/images/boleron/landing/glo.svg" className="glo-info-main-icon" style={{ ...gloIconStyles }} alt="Инфо икона за Глоби от КАТ" />,
    vig: <img src="/images/boleron/landing/vig.svg" className="glo-info-main-icon" style={{ ...gloIconStyles }} alt="Инфо икона за Винетка" />,
    go: <img src="/images/boleron/landing/go.svg" className="glo-info-main-icon" style={{ ...gloIconStyles }} alt="Инфо икона за Гражданска Отговорност" />,
    chr: <img src="/images/boleron/landing/gtp.svg" className="glo-info-main-icon" style={{ ...gloIconStyles }} alt="Инфо икона за ГТП" />
  };

  const lastVerifiedDate = lastVerified ? localDate(new Date(lastVerified)) : "";

  const rowDataHTML = () => (
    <>
      {rowData.map((row, indx) => (
        <p className="glo-row-data is-size-5" key={indx}>
          {row}
        </p>
      ))}
    </>
  );

  return (
    <div className="glo-info-box-container" style={{ ...containerStyles }}>
      {customIcon || icons[iconType]}

      <div className="glo-info-text-box">
        <p className="is-extra-bold-family is-size-3-5 is-uppercase">{title}</p>
        {lastVerifiedDate && <p className="is-size-5">{`${t("toDate", "Към дата")}: ${lastVerifiedDate}`}</p>}
        <p className={`glo-info-subtitle mt-3 ${status} mb-1`}>{subtitle}</p>

        {isRowsAboveBtn && rowDataHTML()}

        {isBuyBtn ? (
          <button
            type="button"
            onClick={() => {
              navigate(buyBtnUrl);
              if (onBuyBtnClick) {
                onBuyBtnClick();
              }
            }}
            className={`glo-buy-btn ${isRowsAboveBtn ? "mt-2" : ""} ${iconType === "go" ? "mt-3" : ""}`}
          >
            {t("Buy online", "Купи онлайн")}
          </button>
        ) : (
          !isRowsAboveBtn && rowDataHTML()
        )}

        <div className={`${status === "loading" ? "glo-loader-style" : ""}`}>{statusIcons[status]}</div>
      </div>
    </div>
  );
};

export default GloInfoBox;
